import { Box } from "@mui/material";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import importedStyles from "../../styles/Inbox.module.css";
import { Link as RouterLink } from "react-router-dom";

export default function SocialPostCard() {
  return (
    <RouterLink to="/social-posts/o9ij3wd3" className="tms-no-underline">
      <Box
        sx={{
          height: "290px",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: 1,
        }}
      >
        <Box
          sx={{
            height: "190px",
            backgroundColor: "#7f7f7f14",
            position: "relative",
          }}
        >
          <Box sx={styles.smTag}>lg</Box>
          <img
            src="https://placehold.co/190"
            alt="social post image"
            className={importedStyles.socialPostImg}
          />
        </Box>

        <Box sx={styles.bottomContainer}>
          <Box as="p" sx={styles.snippet}>
            Meet the Walnut Console — solid wood, felt-lined drawers, and free
            white-glove delivery this week only. Tap to shop the collection
          </Box>

          <Box sx={styles.statsWrapper}>
            <Box sx={styles.statsWrapper}>
              <Box as="p" sx={styles.stats}>
                <FavoriteBorderOutlinedIcon sx={{ fontSize: 17 }} />
                2,133
              </Box>
              <Box as="p" sx={styles.stats}>
                <ModeCommentOutlinedIcon sx={{ fontSize: 17 }} />
                100
              </Box>
            </Box>

            <Box
              as="p"
              sx={{
                color: "#98a29a",
                fontFamily: "FustatMedium",
                fontSize: "12px",
                m: 0,
              }}
            >
              4d
            </Box>
          </Box>
        </Box>
      </Box>
    </RouterLink>
  );
}

const styles = {
  smTag: {
    position: "absolute",
    top: "7px",
    left: "7px",
    padding: "3px 7px",
    borderRadius: "6px",
    fontFamily: "FustatBold",
    fontSize: "12px",
    backgroundColor: "#ad084a",
    color: "#ffffff",
  },
  bottomContainer: {
    height: "100px",
    backgroundColor: "#ffffff",
    padding: "14px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "10px",
  },
  statsWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    justifyContent: "space-between",
  },
  stats: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    color: "#6b746b",
    fontSize: "13px",
    fontFamily: "FustatRegular",
    m: 0,
  },
  snippet: {
    color: "#28382d",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "14px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
  },
};
